<template>
  <Teleport to="body">
    <div class="toast-host" aria-live="polite" aria-relevant="additions">
      <transition-group name="toast">
        <div
          v-for="t in toasts"
          :key="t.id"
          :class="['toast', t.kind || '']"
          :role="t.kind === 'error' ? 'alert' : 'status'"
        >
          <IconX v-if="t.kind === 'error'" :size="16" style="color:#dc2626;flex-shrink:0" />
          <IconAlert v-else-if="t.kind === 'warning'" :size="16" style="color:#d97706;flex-shrink:0" />
          <IconCheckCircle v-else :size="16" style="color:#16a34a;flex-shrink:0" />
          <span class="toast-msg">{{ t.msg }}</span>
          <button class="toast-close" aria-label="Dismiss" @click="dismiss(t.id)">
            <IconX :size="14" />
          </button>
        </div>
      </transition-group>
    </div>
  </Teleport>
</template>

<script>
import { IconX, IconAlert, IconCheckCircle } from '@/components/icons'
import { useToast } from '@/composables/useToast'

export default {
  name: 'ToastHost',
  components: { IconX, IconAlert, IconCheckCircle },
  setup() {
    const { toasts, dismiss } = useToast()
    return { toasts, dismiss }
  }
}
</script>
